export function Skeleton({ className = '' }: { className?: string }) {
  return <div className={['animate-pulse rounded-lg bg-ink-100', className].join(' ')} />;
}

export function CardSkeleton() {
  return (
    <div className="rounded-2xl border border-ink-100 bg-surface p-4 shadow-soft">
      <Skeleton className="mb-3 h-11 w-11 rounded-xl" />
      <Skeleton className="mb-2 h-6 w-16" />
      <Skeleton className="h-3.5 w-24" />
    </div>
  );
}

export function RowSkeleton() {
  return (
    <div className="flex items-center gap-3 border-b border-ink-100 p-4">
      <Skeleton className="h-10 w-10 rounded-full" />
      <div className="flex-1 space-y-2">
        <Skeleton className="h-3.5 w-1/3" />
        <Skeleton className="h-3 w-1/2" />
      </div>
    </div>
  );
}
